import React from 'react';

import './animation.scss';



const Animation = ({ tag, header, type }) => {
  const animationName = type ? type :
    tag === 'graf/packaging' || tag === 'web' || tag === 'interior' || tag === 'urban/improvement' ? 'cubes'
      : tag === 'branding' || tag === 'pr/video' ? 'blobs'
      : tag === 'prom' || tag ==='interface' ? 'glass'
      : tag === 'pr' || tag ==='navigation' ? 'tube'
      : tag === 'smm' || tag ==='urban' || tag === 'inclusive' || tag === 'web/online-store' ? 'figures'
      : 'rings';

  const ticker = React.useRef();

  React.useEffect(() => {
    const el = ticker.current;

    if (!el) {
      return;
    }

    const width = el.clientWidth;
    const coef = (width / 1000).toFixed(1);
    el.style.animationDuration = `${coef * 6}s`;
  }, []);



  return (
      <React.Fragment>
        <div className="animation sheen-container">
          <div className="sheen-scene sheen-w100 sheen-h100 sheen-media-h75 sheen-h100-margin-top sheen-media-h75-margin-top"
               data-scene={
                 animationName === 'tube' ? `/competencies/models/${animationName}.glb` : `/competencies/models/${animationName}-meshopt.glb`
               }
               data-fallback={
                 animationName !== 'tube' ? `/competencies/models/${animationName}.glb` : null
               }
               data-lights="/competencies/hdri/studio_small_04_256.hdr"
               data-lightsrot={
                 animationName === 'glass' ? '[0,0,0]' : null
               }
          />
          <div
              className="sheen-preview sheen-loading-screen sheen-w100 sheen-h100 sheen-media-h175 sheen-h100-margin-top sheen-media-h175-margin-top"
              style={{ backgroundImage: `url(/competencies/images/${animationName}-thumbnail.jpg)` }}
          />
          {/*
          Сергей Кулинкович: «Убрать везде бегущие строки»

          {
            header &&
            <div className="ticker">
              <h2 ref={ticker} className="ticker__text">
                {header}
              </h2>
            </div>
          }
          */}
          <div className="sheen-progressBar"/>
        </div>
      </React.Fragment>
  );
}

export default Animation;
